import {BaseModel} from '../Base/Base.model';

const ModelName = 'FollowerModel';

export class FollowerModel extends BaseModel {
  constructor(props: FollowerModel.Props) {
    super(props);
    Object.assign(this, props);
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace FollowerModel {
  export type Props = BaseModel.ModelToProps<FollowerModel>;
}
